/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MaintenanceStatusDto } from '../models';
// @ts-ignore
import type { MaintenanceWindowCreationRequestDto } from '../models';
// @ts-ignore
import type { MaintenanceWindowDto } from '../models';
/**
 * RestMaintenanceApi - axios parameter creator
 */
export const RestMaintenanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Switch maintenance mode on now or schedule it
         * @param {MaintenanceWindowCreationRequestDto} maintenanceWindowCreationRequestDto Maintenance window to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenanceWindow: async (maintenanceWindowCreationRequestDto: MaintenanceWindowCreationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'maintenanceWindowCreationRequestDto' is not null or undefined
            assertParamExists('createMaintenanceWindow', 'maintenanceWindowCreationRequestDto', maintenanceWindowCreationRequestDto)
            const localVarPath = `/api/admin/maintenance-windows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(maintenanceWindowCreationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary End an active maintenance window now or cancel a planned one
         * @param {number} maintenanceWindowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishMaintenanceWindow: async (maintenanceWindowId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'maintenanceWindowId' is not null or undefined
            assertParamExists('finishMaintenanceWindow', 'maintenanceWindowId', maintenanceWindowId)
            const localVarPath = `/api/admin/maintenance-windows/{maintenanceWindowId}/finish`
                .replace('{maintenanceWindowId}', encodeURIComponent(String(maintenanceWindowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Tell the current user whether maintenance mode is on and whether they may keep working
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/maintenance/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List planned, active and recent maintenance windows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceWindows: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/maintenance-windows`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestMaintenanceApi - functional programming interface
 */
export const RestMaintenanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestMaintenanceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Switch maintenance mode on now or schedule it
         * @param {MaintenanceWindowCreationRequestDto} maintenanceWindowCreationRequestDto Maintenance window to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMaintenanceWindow(maintenanceWindowCreationRequestDto: MaintenanceWindowCreationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceWindowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMaintenanceWindow(maintenanceWindowCreationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMaintenanceApi.createMaintenanceWindow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary End an active maintenance window now or cancel a planned one
         * @param {number} maintenanceWindowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishMaintenanceWindow(maintenanceWindowId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceWindowDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishMaintenanceWindow(maintenanceWindowId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMaintenanceApi.finishMaintenanceWindow']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Tell the current user whether maintenance mode is on and whether they may keep working
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaintenanceStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaintenanceStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaintenanceStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMaintenanceApi.getMaintenanceStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List planned, active and recent maintenance windows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaintenanceWindows(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MaintenanceWindowDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaintenanceWindows(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestMaintenanceApi.getMaintenanceWindows']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestMaintenanceApi - factory interface
 */
export const RestMaintenanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestMaintenanceApiFp(configuration)
    return {
        /**
         * 
         * @summary Switch maintenance mode on now or schedule it
         * @param {MaintenanceWindowCreationRequestDto} maintenanceWindowCreationRequestDto Maintenance window to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMaintenanceWindow(maintenanceWindowCreationRequestDto: MaintenanceWindowCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceWindowDto> {
            return localVarFp.createMaintenanceWindow(maintenanceWindowCreationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary End an active maintenance window now or cancel a planned one
         * @param {number} maintenanceWindowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishMaintenanceWindow(maintenanceWindowId: number, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceWindowDto> {
            return localVarFp.finishMaintenanceWindow(maintenanceWindowId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Tell the current user whether maintenance mode is on and whether they may keep working
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceStatus(options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceStatusDto> {
            return localVarFp.getMaintenanceStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List planned, active and recent maintenance windows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaintenanceWindows(options?: RawAxiosRequestConfig): AxiosPromise<Array<MaintenanceWindowDto>> {
            return localVarFp.getMaintenanceWindows(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestMaintenanceApi - interface
 */
export interface RestMaintenanceApiInterface {
    /**
     * 
     * @summary Switch maintenance mode on now or schedule it
     * @param {MaintenanceWindowCreationRequestDto} maintenanceWindowCreationRequestDto Maintenance window to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMaintenanceWindow(maintenanceWindowCreationRequestDto: MaintenanceWindowCreationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceWindowDto>;

    /**
     * 
     * @summary End an active maintenance window now or cancel a planned one
     * @param {number} maintenanceWindowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    finishMaintenanceWindow(maintenanceWindowId: number, options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceWindowDto>;

    /**
     * 
     * @summary Tell the current user whether maintenance mode is on and whether they may keep working
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMaintenanceStatus(options?: RawAxiosRequestConfig): AxiosPromise<MaintenanceStatusDto>;

    /**
     * 
     * @summary List planned, active and recent maintenance windows
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMaintenanceWindows(options?: RawAxiosRequestConfig): AxiosPromise<Array<MaintenanceWindowDto>>;

}

/**
 * RestMaintenanceApi - object-oriented interface
 */
export class RestMaintenanceApi extends BaseAPI implements RestMaintenanceApiInterface {
    /**
     * 
     * @summary Switch maintenance mode on now or schedule it
     * @param {MaintenanceWindowCreationRequestDto} maintenanceWindowCreationRequestDto Maintenance window to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createMaintenanceWindow(maintenanceWindowCreationRequestDto: MaintenanceWindowCreationRequestDto, options?: RawAxiosRequestConfig) {
        return RestMaintenanceApiFp(this.configuration).createMaintenanceWindow(maintenanceWindowCreationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary End an active maintenance window now or cancel a planned one
     * @param {number} maintenanceWindowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public finishMaintenanceWindow(maintenanceWindowId: number, options?: RawAxiosRequestConfig) {
        return RestMaintenanceApiFp(this.configuration).finishMaintenanceWindow(maintenanceWindowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Tell the current user whether maintenance mode is on and whether they may keep working
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMaintenanceStatus(options?: RawAxiosRequestConfig) {
        return RestMaintenanceApiFp(this.configuration).getMaintenanceStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List planned, active and recent maintenance windows
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMaintenanceWindows(options?: RawAxiosRequestConfig) {
        return RestMaintenanceApiFp(this.configuration).getMaintenanceWindows(options).then((request) => request(this.axios, this.basePath));
    }
}

